export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-target-6e21482e04522cc9b365e076aa06ccee.svg";